import AppCard1 from '../AppCards/AppCard1';
import InlineStyled from '../InlineStyled/InlineStyled';

const AppTipsUI = ({ children }) => {
  return (
    <AppCard1>
      <InlineStyled
        $style={{
          color: '#465364',
          fontSize: 18,
          fontWeight: 600,
          textAlign: 'center',
          lineHeight: 'normal',
          marginBottom: 16,
        }}
      >
        Tips
      </InlineStyled>
      {children}
    </AppCard1>
  );
};

export default AppTipsUI;
